import { connect } from "react-redux";
import AppModal from "../components/AppModal";
import { sessionSlice } from "../../store/sessionSlice";

const mapStateToProps = (state) => {
  return {
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
    isConnected: state.session.isConnected,
    isAdmin: state.session.userType === "admin",
    status: state.session.sessionStatus,
    message: state.session.sessionMsg
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onResetErrors : () => {
      dispatch(sessionSlice.actions.resetErrors());
    }
  };
};

export const AppModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppModal);
